"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cars = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var BreadCrumpPage_1 = require("../../components/breadCrumpPage/BreadCrumpPage");
var InStockList = react_1.default.lazy(function () {
    return Promise.resolve().then(function () { return __importStar(require('../../components/inStockList/InStockList')); }).then(function (module) { return ({ default: module.InStockList }); });
});
var CarSelection = react_1.default.lazy(function () {
    return Promise.resolve().then(function () { return __importStar(require('../../components/carSelection/CarSelection')); }).then(function (module) { return ({ default: module.CarSelection }); });
});
var CarsFilter = react_1.default.lazy(function () {
    return Promise.resolve().then(function () { return __importStar(require('../../components/carsFilter/CarsFilter')); }).then(function (module) { return ({ default: module.CarsFilter }); });
});
var Cars = function () {
    var _a = (0, react_router_dom_1.useParams)(), brand = _a.brand, model = _a.model, generation = _a.generation;
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var crumpsLink = [];
    var getFiltersCrupms = Array.from(searchParams.entries()).filter(function (_a) {
        var key = _a[0], value = _a[1];
        return ['brand_name', 'model_name', 'generation_name'].includes(key) && !['Все марки', 'Все модели', 'Поколения'].includes(value);
    }).map(function (_a) {
        var key = _a[0], value = _a[1];
        crumpsLink.push("".concat(key, "=").concat(value));
        return ({ name: value, url: "/cars?".concat(crumpsLink.join('&')) });
    });
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "page" },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: __spreadArray([
                    { name: 'Главная', url: '/' },
                    { name: 'Авто с пробегом', url: '/cars' }
                ], getFiltersCrupms, true) }),
            react_1.default.createElement("h1", { className: "page__title" }, !brand ? 'Купить автомобиль в Москве' : "".concat(brand, " ").concat(model || '', " ").concat(generation || '')),
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...") },
                react_1.default.createElement(InStockList, null),
                react_1.default.createElement(CarSelection, null),
                react_1.default.createElement(CarsFilter, null)))));
};
exports.Cars = Cars;
